import { ALARM_SERVICE_NAME, AlarmServiceProvider } from './alarm.service'
import { ALARM_CONTEXT_MENU_SERVICE_NAME, AlarmContextMenuServiceProvider } from './alarm.context-menu.service'

export const ALARM_SERVICES_MODULE_NAME = 'simax.services.alarm'

const module = angular.module(ALARM_SERVICES_MODULE_NAME, [])

module.provider(ALARM_SERVICE_NAME, AlarmServiceProvider)
module.provider(ALARM_CONTEXT_MENU_SERVICE_NAME, AlarmContextMenuServiceProvider)
